import { 
    LOAD_CHANGE_LOG_DATA_IN_PROGRESS,
    LOAD_CHANGE_LOG_DATA_SUCCESS,
    LOAD_CHANGE_LOG_DATA_FAILURE,
    LOAD_CHANGE_LOG_TYPE_LIST_SUCCESS,
    LOAD_CHANGE_LOG_SUBTYPE_LIST_SUCCESS
} from "./actions";
  
    const initialState = { isLoading: false, changeLogListData: [],changeLogTypeList:[],changeLogSubTypeList:[]};
    export const changelog = (state = initialState, action) => {
        const { type, payload } = action;
        switch (type) {
            case LOAD_CHANGE_LOG_DATA_SUCCESS: {
                const { data } = payload;
                return {
                    ...state,
                    isLoading: false,
                    changeLogListData: data,
                };
            }     
            case LOAD_CHANGE_LOG_DATA_IN_PROGRESS:
            return {
                ...state,
                isLoading: true,
            };
            case LOAD_CHANGE_LOG_DATA_FAILURE:
            return {
                ...state,
                isLoading: false,
            };
            case LOAD_CHANGE_LOG_TYPE_LIST_SUCCESS: {
                const { data } = payload;
                return {
                  ...state,
                  changeLogTypeList: data,
                };
            };
            case LOAD_CHANGE_LOG_SUBTYPE_LIST_SUCCESS: {
                const { data } = payload;
                return {
                  ...state,
                  changeLogSubTypeList: data,
                };
            }
            default:
                return state;
        }
    };
  